import { styled } from "styled-components";
import { rgba } from "polished";

const Container = styled.li`
    background-color: ${({ backgroundColor }) => backgroundColor};
    padding: 5px;

    border-radius: 5px;

    transition: all 200ms;
    
    a {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }

    p {
        color: white;
        font-family: ${({ theme }) => theme.fonts.sub};
        font-weight: ${({ theme }) => theme.fontWeight.medium};
    }
    
    &:hover {
        cursor: pointer;
        box-shadow: 0px 0px 3px 4px ${({ backgroundColor }) => rgba(backgroundColor, .2)};
        
    }
`;

export function Badge({ name, icon, backgroundColor, href }) {
    return (
        <Container backgroundColor={backgroundColor}>
            <a href={href} target="_blank" rel="noopener noreferrer">
                <span>
                    {icon}
                </span>
                <p>
                    {name}
                </p>
            </a>
        </Container>
    )
}